// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".insuranceQuoteForm[data-v-0e9f4770]{display:grid;grid-template-columns:1fr 1fr}.url-container[data-v-0e9f4770]{display:flex;flex-direction:column}[data-v-0e9f4770]:v-deep(.md-dialog-container){width:80%}", ""]);
// Exports
module.exports = exports;
